import clsx from 'clsx';

import { useConfig } from '../context/Config';
import { useIcon } from '../context/Icons';
import { ListItem } from './ListItem';

export const List = () => {
  const { filteredIcons: icons, openIcon } = useIcon();
  const { listItemStyles } = useConfig();

  const handleIconClick = (iconId: number) => {
    openIcon(iconId);
  };

  if (icons) {
    return (
      <div className={clsx('icon-library--list-wrapper', `overflow-hidden overflow-y-auto flex-grow-0 pl-2 pr-2`)}>
        <div className={clsx('icon-library--list', `flex flex-wrap justify-start gap-4 pb-8`)}>
          {icons.map(icon => (
            <ListItem key={icon.id} onClick={handleIconClick} customStyles={listItemStyles} {...icon} />
          ))}
        </div>
      </div>
    );
  }

  return null;
};
